import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Bar } from 'react-chartjs-2'; 
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement,Filler,} from 'chart.js';

// Registering the necessary chart elements
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement,Filler);
interface AttendanceData {
    absence_count: number;
    user_id: number;
}

  interface UserStructure {
    profile: string;
    id: number;
    name: string;
    email: string;
    delete: number;
    role:string;
    designation:string;
    company_name:string;
  }

  interface BusinessStructure {
  giver :number; 
  receiver: number;
  workBy:string;
  referenceId:string;
  status : string;
  date:string;
  amount:number;
  Testimonial :string;
  }
const DashboardHome = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [attendanceData, setAttendanceData] = useState<any[]>([]);
  const [userData, setUserData] = useState<UserStructure[]>([]); // Added user data state
  const [totalAbsences, setTotalAbsences] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState<number | null>(null);
  const [totalReferenceCount, setTotalReferenceCount] = useState<number | null>(null);
  const [businessData, setBusinessData] = useState<BusinessStructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/business`);

        // console.log("business data", response.data.data);
        setBusinessData(response.data.data);
        // console.log("report data in a array", businessData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    let total = 0;
    businessData.forEach((item) => {
      total += item.amount;
    });
    // console.log(total);
    setTotalAmount(total); // Update the state with the calculated total amount
  }, [businessData]);


  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${api}/auth/allusersinfo`);
        setUserData(response.data); // Assuming the response contains user data with profile image and name
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [api]);

  // Fetch total reference count
  useEffect(() => {
    const getTotalReferenceCount = async () => {
      try {
        const response = await axios.get(`${api}/auth/totalreference`);
        setTotalReferenceCount(response.data.data.total_reference_count); // Assuming the response is a single number
      } catch (error) {
        console.error('Error fetching reference count:', error);
      }
    };

    getTotalReferenceCount();
  }, [api]);

  // Fetch total business count
  useEffect(() => {
    const fetchTotalBusinessCount = async () => {
      try {
        const response = await axios.get(`${api}/auth/totalbusiness`);
        setTotalCount(response.data.data.total_count); // Assuming the response is a single number
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchTotalBusinessCount();
  }, [api]);

  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await axios.get(`${api}/auth/totalabsense`);
        setAttendanceData(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching attendance data:', error);
        setLoading(false);
      }
    };

    fetchAttendanceData();
  }, []);

  const chartData = {
    labels: attendanceData.filter((abs)=>abs.absence_count>=1).map((item: any) => {
        const user = userData.find((user: any) => user.id === Number(item.user_id));
        
        if (user) {
        //   console.log('User found:', user); // Debugging user data
          return `${user.name}`;
        } else {
        //   console.log('User not found for item:', item); // Debugging item data
          return `User ${item.user}`;
        }
    }),
    datasets: [
      {
        label: 'Absence Count',
        // data: attendanceData.map((item: any) => ({
        //   absence_count: item.absence_count,
        //   user_id: item.user_id,
        // })), 
        data: attendanceData.map((item: any) => item.absence_count),
        
        // backgroundColor: 'rgba(75, 192, 192, 0.6)',
        // backgroundColor: 'rgb(242, 249, 255)',
        backgroundColor: attendanceData.map((item: any) =>
          item.absence_count >= 5 ? 'rgb(255, 0, 0)' : 'rgb(242, 249, 255)'
        ),
        fill: true,
      },
    ],
  };

  if (loading) return <p>Loading...</p>;

  // Graph data for total business and reference count (using single values)
  const businessAndReferenceGraphData = {
    labels: ['Business Count', 'Reference Count'], // X-axis with only two categories
    datasets: [
      {
        label: 'Counts',
        data: [totalCount, totalReferenceCount], // Array with both total counts
        borderColor: '#3B82F6', // Blue color for business count
        backgroundColor: 'rgba(59, 130, 246, 0.2)',
        fill: true,
        tension: 0.4,
        pointRadius: 5,
        pointBackgroundColor: '#3B82F6',
      },
    ],
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">User Attendance Dashboard</h1>
      
      {/* Card for Total Absences */}
      



      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-4">
  {/* User Absences */}
  <div className="h-96 overflow-y-auto p-6 rounded shadow-md hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 scrollbar-hide">
    <h2 className="text-xl font-semibold mb-4 text-textyellow">User Absences</h2>
    <table className="min-w-full table-auto ">
      <thead>
        <tr className="bg-gray-200">
          <th className="px-4 py-2 text-left">User Name</th>
          <th className="px-4 py-2 text-left">Absence Count</th>
        </tr>
      </thead>
      <tbody>
        {attendanceData
          .filter((abse) => abse.absence_count >= 1)
          .map((item: any, index: number) => {
            const user = userData.find(
              (user: any) => user.id === Number(item.user_id)
            );
            return (
              <tr key={index} className="border-b">
                <td className="px-4 py-2 text-white">{user ? user.name : "Unknown User"}</td>
                <td className="px-4 py-2 text-white">{item.absence_count}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  </div>

  {/* Total Business and Total Reference */}
  <div className="flex flex-col gap-4">
    <div className="shadow-md hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-4 rounded flex-grow">
      <h2 className="text-xl font-semibold text-textyellow">Total Business</h2>
      <p className="text-4xl font-bold text-white"> ₹{new Intl.NumberFormat('en-IN').format(totalAmount)}</p>
     

    </div>
    <div className="shadow-md hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-4 rounded  flex-grow">
      <h2 className="text-xl font-semibold text-textyellow">Total Reference</h2>
      <p className="text-4xl font-bold text-white">{totalReferenceCount || "0"}</p>
    </div>
  </div>
</div>

      <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded shadow-md mb-6">
      <h2 className="text-xl font-semibold mb-4 text-white">Absence Count Visualization</h2>
      <Bar
  data={chartData}
  options={{
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hides the label in the legend
      },
      
      tooltip: {
        callbacks: {
          label: function (context: any) {
            // Extract the raw data for the current bar
            const rawData = context.raw as { absence_count: number; user_id: number };

            // Check if rawData exists and meets the condition
            if (context.raw > 0) {
              const absenceCount = rawData.absence_count;
              const user = userData.find((user: any) => user.id === rawData.user_id);

              if (user) {
                // If user found, return their name and absence count
                return `${user.name} - Absence: ${absenceCount}`;
              } else {
                // If user not found, just return absence count
                return `Absence: ${context.raw}`;
              }
            } else {
              // Do not show tooltip for users with absences <= 4
              return '';
            }
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: attendanceData.map((item: any) =>
            item.absence_count >=5 ? 'rgb(255, 0, 0)' : 'rgb(242, 249, 255)'
          ), // Dynamic label color for x-axis
          font: {
            size: 12,
          },
        },
      },
      y: {
        ticks: {
          color: 'white', // Static color for y-axis labels
          font: {
            size: 12,
          },
        },
      },
    },
  }}
/>

      

    </div>

      {/* Total Business & Reference Line Chart */}
      <div className="bg-white p-6 rounded shadow-md mb-6 hidden">
        <h2 className="text-xl font-semibold mb-4">Business & Reference Counts</h2>
        <Bar data={businessAndReferenceGraphData} options={{ responsive: true }} />
      </div>

      
    </div>
  );
};

export default DashboardHome;
